import { render, staticRenderFns } from "./DecisionSimple.vue?vue&type=template&id=262bdc34"
import script from "./DecisionSimple.vue?vue&type=script&lang=js"
export * from "./DecisionSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports